import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { FourOhFourPage } from "@pages/fourOhFourPage";
import { RouterContext } from "@config/tanstack";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: FourOhFourPage,
});
